











import Vue from 'vue';
import { RegistrableProvide } from './helpers/registerable';

export default Vue.extend({
  name: 'form-component',
  mixins: [RegistrableProvide('form')],
  data: function() {
    return {
      fields: [] as any[]
    };
  },
  methods: {
    register: function(field: Vue) {
      this.fields.push(field);
    },
    unregister: function() {
      // TODO: Implement unregister
      // const found = this.inputs.find(i => i._uid === input._uid)
      // if (!found) return
      // const unwatch = this.watchers.find(i => i._uid === found._uid)
      // unwatch.valid && unwatch.valid()
      // unwatch.shouldValidate && unwatch.shouldValidate()
      // this.watchers = this.watchers.filter(i => i._uid !== found._uid)
      // this.inputs = this.inputs.filter(i => i._uid !== found._uid)
      // this.$delete(this.errorBag, found._uid)
    },
    dirty: function() {
      return !!this.fields.filter(fields => fields.dirty).length;
    },
    validate: function() {
      return !this.fields.filter(field => !field.validate(true)).length;
    },
    resetValidation: function() {
      this.fields.forEach(field => field.resetValidation());
    },
    restore: async function() {
      this.fields.forEach(field => field.$emit('input', field.initialValue));
      await this.$nextTick();
      this.resetValidation();
    },
    reset: function() {
      const form = this.$el as HTMLFormElement;
      form.reset();
    }
  }
});
